import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	triggerLabel: {
		id: 'business-list.list-view.header-actions.more-menu.trigger-label',
		defaultMessage: 'More actions',
		description: 'Label representing a dropdown menu section name for additional actions.',
	},
});
